import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_ENTERPRISE_SCANNED_IMAGE = 'GET_ENTERPRISE_SCANNED_IMAGE';
export const GET_ENTERPRISE_SCANNED_IMAGE_SUCCESS =
  'GET_ENTERPRISE_SCANNED_IMAGE_SUCCESS';
export const GET_ENTERPRISE_SCANNED_IMAGE_FAILURE =
  'GET_ENTERPRISE_SCANNED_IMAGE_FAILURE';

// Action Creators
export const getEnterpriseScannedImage = () => ({
  type: GET_ENTERPRISE_SCANNED_IMAGE,
});

export const getEnterpriseScannedImageSuccess = (users) => ({
  type: GET_ENTERPRISE_SCANNED_IMAGE_SUCCESS,
  payload: users,
});

export const getEnterpriseScannedImageFailure = (error) => ({
  type: GET_ENTERPRISE_SCANNED_IMAGE_FAILURE,
  payload: error,
});

// Thunk Function
export const getEnterpriseScannedImageCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getEnterpriseScannedImage());
    try {
      const response = await getMethodWithToken(
        url.enterpriseScannedImage + data
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getEnterpriseScannedImageSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        if (external?.handleErrorFunction) {
          external?.handleErrorFunction(response?.data);
        }
      }
    } catch (error) {
      dispatch(getEnterpriseScannedImageFailure(error?.message));
    }
  };
};
